import {
  Component, Inject, forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { OBarMenuModule, OBarMenuComponent } from './o-bar-menu.component';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';



export class OBarMenuSeparatorComponent {

  protected menu: OBarMenuComponent;

  constructor(  menu: OBarMenuComponent) {
    this.menu = menu;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-bar-menu-separator',
  template: `
    <div class="fake-li mat-primary separator"></div>
  `,
  styles: [`
    o-bar-menu-separator .fake-li.separator{border-bottom:2px solid}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OBarMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OBarMenuComponent), ] }, ]},
];
}


export class OBarMenuSeparatorModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OBarMenuSeparatorComponent],
  imports: [OSharedModule, CommonModule, OBarMenuModule],
  exports: [OBarMenuSeparatorComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
